<template lang="html">
  <masked-input
    ref="input"
    type="text"
    class="text-right form-control input-currency"
    :class="['is-' + state]"
    :placeholder="placeholder"
    v-model="valueMask"
    @change="callChange"
    @keyup="callKeyUp"
    @keydown.enter="$emit('keydown.enter', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    :mask="numberMask"
    :guide="true"
    v-bind="$attrs"
  ></masked-input>
</template>

<script>
import MaskedInput from 'vue-text-mask';
import CurrencyMask from '_common/mixins/CurrencyMask';

export default {
  name: 'InputCurrency',
  components: {
    MaskedInput,
  },
  mixins: [CurrencyMask],
  props: {
    parameter: {
      type: [String, Number, Object, Array],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Total',
    },
    model: {
      required: true,
      default: null,
    },
    modelIndex: {
      required: true,
      default: null,
    },
    state: {
      type: String,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      valueMask: '0,00',
    };
  },
  watch: {
    model: {
      handler(value) {
        this.valueMask = this.addDecimalMask(value[this.modelIndex]);
      },
      deep: true,
    },
  },
  methods: {
    callChange() {
      this.model[this.modelIndex] = this.removeDecimalMask(this.valueMask);
      this.onChange(this.model, this.parameter);
    },
    callKeyUp() {
      this.onKeyup(this.model);
    },
    focusInput() {
      const input = this.$refs.input?.$el || this.$refs.input?.el;

      if (input) {
        input.focus();
        input.select();
      }
    },
  },
  mounted() {
    this.valueMask = this.addDecimalMask(this.model[this.modelIndex]);
  },
};
</script>

<style lang="scss" >
.input-group {
  .form-control.input-currency {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
}
</style>
